// A tip's amount as a supporter reads it, apart from shared/src/tips.ts so the browser scripts
// that redraw a Tip box's total (site/src/ui/tip-example.ts) don't carry its schemas.

/** A tip's amount in the site's currency, as a supporter reads it: "$15" or "$2.50". */
export function tipMoney(cents: number, currency: string) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}
